import { BaseXHR } from 'utils/axios';

export const getParkListApi = params =>
  BaseXHR.$get('b2b/reservation/parks', params);
export const getRestaurantListApi = params =>
  BaseXHR.$get('b2b/reservation/stores', params);
export const getTicketShowListApi = params =>
  BaseXHR.$get('b2b/reservation/ticket-shows', params);
export const getZoneListApi = params =>
  BaseXHR.$get('b2b/reservation/zones', params);
export const createBookingSlotApi = data =>
  BaseXHR.$post('b2b/reservation/booking/create', data);
export const updateBookingSlotApi = data =>
  BaseXHR.$post('b2b/reservation/booking/update', data);
export const cancelBookingSlotApi = data =>
  BaseXHR.$post('b2b/reservation/booking/cancel', data);
export const getBookingSlotListApi = params =>
  BaseXHR.$get('b2b/reservation/booking/listing', params);
export const getAvailableBookingSlotApi = params =>
  BaseXHR.$get('b2b/reservation/booking/slots', params);
export const getBookingSlotDetailApi = params =>
  BaseXHR.$get('b2b/reservation/booking/detail/' + params.id);
export const getBookingUpdateStateApi = params =>
  BaseXHR.$get('b2b/reservation/booking/update-states', params);
